module.exports = __webpack_public_path__ + "static/media/RoroBannerAPP-03.eab1cb5d.png";